import axios from 'axios';

export function getUserScreens(token, userId) {
    return axios.get(`${process.env.REACT_APP_API_URL}/getUserScreens?userId=${userId}`, {
        headers: { Authorization: `${token}` },
    });
}
